import { Injectable, inject } from '@angular/core';

import { Observable, forkJoin } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { FlowTriggerModel } from '../models/flow-model.model';
import { DictionaryService } from './dictionary.service';

@Injectable()
export class FlowSummaryPanelService {
  private dictionaryService = inject(DictionaryService);

  public days: any = [
    { id: 1, name: 'M', checked: false },
    { id: 2, name: 'T', checked: false },
    { id: 3, name: 'W', checked: false },
    { id: 4, name: 'T', checked: false },
    { id: 5, name: 'F', checked: false },
    { id: 6, name: 'S', checked: false },
    { id: 7, name: 'S', checked: false },
  ];
  public monthdays: any = [
    { id: 1, name: '1', checked: false },
    { id: 2, name: '2', checked: false },
    { id: 3, name: '3', checked: false },
    { id: 4, name: '4', checked: false },
    { id: 5, name: '5', checked: false },
    { id: 6, name: '6', checked: false },
    { id: 7, name: '7', checked: false },
    { id: 8, name: '8', checked: false },
    { id: 9, name: '9', checked: false },
    { id: 10, name: '10', checked: false },
    { id: 11, name: '11', checked: false },
    { id: 12, name: '12', checked: false },
    { id: 13, name: '13', checked: false },
    { id: 14, name: '14', checked: false },
    { id: 15, name: '15', checked: false },
    { id: 16, name: '16', checked: false },
    { id: 17, name: '17', checked: false },
    { id: 18, name: '18', checked: false },
    { id: 19, name: '19', checked: false },
    { id: 20, name: '20', checked: false },
    { id: 21, name: '21', checked: false },
    { id: 22, name: '22', checked: false },
    { id: 23, name: '23', checked: false },
    { id: 24, name: '24', checked: false },
    { id: 25, name: '25', checked: false },
    { id: 26, name: '26', checked: false },
    { id: 27, name: '27', checked: false },
    { id: 28, name: '28', checked: false },
    { id: 29, name: '29', checked: false },
    { id: 30, name: '30', checked: false },
    { id: 31, name: '31', checked: false },
    { id: 32, name: 'Last Day of the Month', checked: false },
  ];
  public months: any = [
    { id: 1, name: 'January', checked: false },
    { id: 2, name: 'February', checked: false },
    { id: 3, name: 'March', checked: false },
    { id: 4, name: 'April', checked: false },
    { id: 5, name: 'May', checked: false },
    { id: 6, name: 'June', checked: false },
    { id: 7, name: 'July', checked: false },
    { id: 8, name: 'August', checked: false },
    { id: 9, name: 'September', checked: false },
    { id: 10, name: 'October', checked: false },
    { id: 11, name: 'November', checked: false },
    { id: 12, name: 'December', checked: false },
  ];
  public schedules: any[] = [
    {
      ID: 1,
      name: 'Hourly',
    },
    {
      ID: 2,
      name: 'Daily',
    },
    {
      ID: 3,
      name: 'Weekly',
    },
    {
      ID: 4,
      name: 'Monthly',
    },
    {
      ID: 5,
      name: 'On specific dates',
    },
    {
      ID: 7,
      name: 'Event based',
    },
  ];

  getCurrentTrigger(flowTriggers: FlowTriggerModel): string {
    if (!flowTriggers) {
      return null;
    }

    let yo = 'Empty';

    let scheduleid = 0;
    if (flowTriggers.scheduleOptionID && flowTriggers.scheduleOptionID !== -1) {
      scheduleid = this.schedules[flowTriggers.scheduleOptionID - 1].ID;
      if (scheduleid === 1) {
        yo =
          'Every ' + (flowTriggers.repeatEveryHourMinuteValue === null ? '0' : flowTriggers.repeatEveryHourMinuteValue);
        if (!flowTriggers.repeatEveryHourMinute) {
          return yo + '';
        }
        yo +=
          flowTriggers.repeatEveryHourMinute === 'hour'
            ? ' hours'
            : flowTriggers.repeatEveryHourMinute === 'minute'
              ? ' minutes'
              : ' hours/minutes';
        return yo;
      } else if (scheduleid === 2) {
        if (flowTriggers.specificTimeBetween === 'specific time') {
          yo = 'Daily' + '\n' + 'At ' + flowTriggers.timeFrom;
          return yo;
        }
        if (flowTriggers.specificTimeBetween === 'between') {
          yo =
            'Daily' +
            '\n' +
            'Between ' +
            flowTriggers.timeFrom +
            ' to ' +
            flowTriggers.timeTo +
            ' every ' +
            (flowTriggers.repeatEveryHourMinuteValue === null ? '0' : flowTriggers.repeatEveryHourMinuteValue);
          yo +=
            flowTriggers.repeatEveryHourMinute === 'hour'
              ? ' hours'
              : flowTriggers.repeatEveryHourMinute === 'minute'
                ? ' minutes'
                : ' hours/minutes';
          return yo;
        }
      } else if (scheduleid === 3) {
        yo = 'Every ';
        for (let i of this.days) {
          if (i.checked === true) {
            yo +=
              i.id === 1
                ? 'Monday, '
                : i.id === 2
                  ? 'Tuesday, '
                  : i.id === 3
                    ? 'Wednesday, '
                    : i.id === 4
                      ? 'Thursday, '
                      : i.id === 5
                        ? 'Friday, '
                        : i.id === 6
                          ? 'Saturday, '
                          : i.id === 7
                            ? 'Sunday,'
                            : null;
          }
        }
        yo = yo.replace(/,(?=[^,]*$)/, '');
        yo = yo.replace(/,(?=[^,]*$)/, ' and ');
        if (flowTriggers.specificTimeBetween === 'specific time') {
          yo += '\n' + ' At ' + flowTriggers.timeFrom;
        }
        if (flowTriggers.specificTimeBetween === 'between') {
          yo +=
            '\n' +
            ' Between ' +
            flowTriggers.timeFrom +
            ' to ' +
            flowTriggers.timeTo +
            ' every ' +
            (flowTriggers.repeatEveryHourMinuteValue === null ? '0' : flowTriggers.repeatEveryHourMinuteValue);
          yo +=
            flowTriggers.repeatEveryHourMinute === 'hour'
              ? ' hours'
              : flowTriggers.repeatEveryHourMinute === 'minute'
                ? ' minutes'
                : ' hours/minutes';
        }
        if (yo !== 'Every ') {
          return yo;
        }
      } else if (scheduleid === 4) {
        yo = 'Every ';
        let cntflag = 0;
        for (let j of this.monthdays) {
          if (j.checked === true) {
            if (j.id !== 32) {
              yo += j.id + this.ordinal(j.id) + ', ';
            } else {
              yo += 'Last day, ';
            }
            cntflag += 1;
          }
        }
        if (cntflag > 0) {
          yo = yo.replace(/,(?=[^,]*$)/, '');
          yo = yo.replace(/,(?=[^,]*$)/, ' and ');
          yo += ' of the month ';
        }
        if (flowTriggers.specificTimeBetween === 'specific time') {
          yo += '\n' + ' At ' + flowTriggers.timeFrom;
        }
        if (flowTriggers.specificTimeBetween === 'between') {
          yo +=
            '\n' +
            ' Between ' +
            flowTriggers.timeFrom +
            ' to ' +
            flowTriggers.timeTo +
            ' every ' +
            (flowTriggers.repeatEveryHourMinuteValue === null ? '0' : flowTriggers.repeatEveryHourMinuteValue);
          yo +=
            flowTriggers.repeatEveryHourMinute === 'hour'
              ? ' hours'
              : flowTriggers.repeatEveryHourMinute === 'minute'
                ? ' minutes'
                : ' hours/minutes';
        }
        if (yo !== 'Every ') {
          return yo;
        }
      } else if (scheduleid === 5) {
        yo = '';
        if (flowTriggers.whichMonth) {
          let cntmonth = 0;
          let monthString =
            flowTriggers.whichMonth
              .map((monthId) => {
                cntmonth++;
                return this.months.filter(({ id }) => id === monthId)[0]?.name || '';
              })
              .join(', ') + ' ';
          if (cntmonth > 1) {
            monthString = monthString.replace(/,(?=[^,]*$)/, ' and ');
          }
          yo += monthString;
        }

        if (flowTriggers?.whichYear?.length) {
          yo += `${flowTriggers.whichYear.join(', ')} `;
        }

        let chosendays = '';
        let cntdays = 0;

        for (let j of this.monthdays) {
          if (j.checked === true) {
            if (j.id !== 32) {
              chosendays += j.id + this.ordinal(j.id) + ', ';
            } else {
              chosendays += 'Last day, ';
            }
            cntdays += 1;
          }
        }
        if (cntdays > 0) {
          yo += '\n' + 'On the ';
          yo += chosendays;
          yo = yo.replace(/,(?=[^,]*$)/, '');
          yo = yo.replace(/,(?=[^,]*$)/, ' and ');
          yo += ' of the month ';
        }
        if (flowTriggers.specificTimeBetween === 'specific time') {
          yo += '\n' + ' At ' + flowTriggers.timeFrom;
        }
        if (flowTriggers.specificTimeBetween === 'between') {
          yo +=
            '\n' +
            ' Between ' +
            flowTriggers.timeFrom +
            ' to ' +
            flowTriggers.timeTo +
            ' every ' +
            (flowTriggers.repeatEveryHourMinuteValue === null ? '0' : flowTriggers.repeatEveryHourMinuteValue);
          yo +=
            flowTriggers.repeatEveryHourMinute === 'hour'
              ? ' hours'
              : flowTriggers.repeatEveryHourMinute === 'minute'
                ? ' minutes'
                : ' hours/minutes';
        }
        if (yo.length) {
          return yo;
        }
      }
    }
  }

  ordinal(n) {
    return ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th';
  }

  public getFlowActionsSummary(flowActions): Observable<{ applicationName: string; actionNames: string }[]> {
    return forkJoin({
      actionsOptions: this.dictionaryService.getApplicationViews(),
      actionTypes: this.dictionaryService.getActionTypes(),
    }).pipe(
      map(({ actionsOptions, actionTypes }: any) => {
        const applicationsDict = actionsOptions.reduce((acc, item) => {
          acc[item.id] = item.name;
          return acc;
        }, {});
        const actionsDict = actionTypes.reduce((acc, item) => {
          acc[item.id] = item.name;
          return acc;
        }, {});

        const groupedApps = flowActions.reduce((acc, action) => {
          if (action.actionRowID === 0) {
            return acc;
          }
          if (!acc.get(action.applicationID)) {
            acc.set(action.applicationID, []);
          }
          acc.set(action.applicationID, [...acc.get(action.applicationID), action.actionTypeID]);
          return acc;
        }, new Map());

        const flowActionsSummary: { applicationName: string; actionNames: string }[] = [];
        groupedApps.forEach((val, key) => {
          flowActionsSummary.push(...val.map((act) => `${applicationsDict[key]} - ${actionsDict[act]}`));
        });

        return flowActionsSummary;
      }),
    );
  }
}
